<form action="JavaScript:" [formGroup]="form">

  <div class="logo">
    <img src="/assets/logo_large.svg">
  </div>

  <div class="title">Войдите в аккаунт</div>

  <div class="form-field">
    <div class="form-field-label">Email</div>
    <input type="email" placeholder="Введите свой Email" formControlName="Login">
  </div>

  <div class="form-field">
    <div class="form-field-label">Пароль</div>
    <input type="password" placeholder="Введите свой пароль" formControlName="Password">
  </div>

  <button [disabled]="form.invalid" (click)="login()" class="button-black">Войти</button>

</form>
